<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            v-if="loaded"
            :table-data="preOrders"
            @dataUpdated="queriedData = $event"
        >
            <div slot="header">
                <div class="flex-end">
                    <base-button
                        v-if="preOrders.length"
                        type="primary"
                        @click="showNewPreOrder = true"
                    >
                        Add Pre-Order
                    </base-button>
                </div>
            </div>
            <pre-orders-table
                v-if="preOrders.length"
                :pre-orders="queriedData"
                :exclude-columns="excludedColumns"
            />
            <div v-else class="text-center">
                <h4 class="mb-3">You have no Pre-Orders.</h4>
                <base-button type="primary" @click="showNewPreOrder = true">
                    Add Pre-Order
                </base-button>
            </div>
        </table-search-and-pagination>
        <new-pre-order v-if="showNewPreOrder" :show.sync="showNewPreOrder" />
    </div>
</template>
<script>
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import NewPreOrder from "src/modules/PreOrder/NewPreOrder";
import PreOrdersTable from "./PreOrdersTable.vue";

export default {
    name: "PreOrders",
    components: {
        NewPreOrder,
        PreOrdersTable,
        TableSearchAndPagination,
    },
    props: {
        loaded: {
            type: Boolean,
            required: true,
        },
        preOrders: {
            type: Array,
            required: true,
        },
        excludedColumns: {
            type: Array,
        },
    },
    data() {
        return {
            showNewPreOrder: false,
            queriedData: [],
        };
    },
};
</script>
